// UI ACTIONS
export const IS_LOADING = 'IS_LOADING';
export const IS_SHOW_ACTIVITY_MENU = 'IS_SHOW_ACTIVITY_MENU';
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB';
export const IS_SHOW_NAV_BAR = 'IS_SHOW_NAV_BAR';
export const IS_SHOW_SIDE_BAR = 'IS_SHOW_SIDE_BAR';
export const UI_ERROR = 'UI_ERROR';

// MAILCHIMP SUBSCRIBERS
export const SUBSCRIBER_COUNT = 'SUBSCRIBER_COUNT';
export const ADD_SUBSCRIBER = 'ADD_SUBSCRIBER';

// POSTS
export const ADD_POSTS = 'ADD_POSTS';
export const ADD_POST = 'ADD_POST';
export const REMOVE_POST = 'REMOVE_POST';
export const ADD_COMMENT = 'ADD_COMMENT';

// CATEGORIES
export const ADD_CATEGORIES = 'ADD_CATEGORIES';

// SET ERROR
export const SET_ERROR = 'SET_ERROR';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js